<template>
  <div v-html="publicHtmlContent" />
</template>
<script lang="ts">
/**
 * YHC は public 用 画像配信ドメインと 管理画面用のドメインが異なるので、
 * 管理画面から 投入した HTML Content (WYSIWYG など) の画像ドメインを public 用のドメインに変換する
 *
 * 画像の URL yhc-core-files.core-fw.com を yhc-core-files-public.core-fw.com に replaceする
 *
 * ## 画像URL変換挙動
 * - 例: ` src="https://yhc-core-files.core-fw.com/u/3xnu0ulu/bed_sunpo.png?ixlib=js-3.8.0&Policy=eyJTdGF0ZW1lbnQiOlt7IlJlc291cmNlIjoiaHR0cHM6Ly95aGMtY29yZS1maWxlcy5jb3JlLWZ3LmNvbS8qIiwiQ29uZGl0aW9uIjp7IkRhdGVMZXNzVGhhbiI6eyJBV1M6RXBvY2hUaW1lIjoxNzExMjQyMzU0fX19XX0_&Key-Pair-Id=K3E0A4JOZ2YXBH&Signature=JhYFu0YnKeGcaGBoeXwhMNpXA8TuX19rtyJWW3n-9kaNBnVUyzRpW0f-By0SJasreavJcWPXMetSUfc3S7PnKMTpnvRCKmJyZIGAO0GJDwbd3l4MlYlbydwxl1Nbqd2bAX2ycKkqQ5tiRZ17pIBHlj2SyEfr7Ey94P7r-YFpCV9sqq6dIfMqvNhWjQANEBSq5z-nG0n4~PMoDcRMLFdEM1m48UXwOmRbyt~rP0l-g98Q9VycWtrSmIMBWOfwQXSKgEUf8Gjrfel0sp~19G0Po9Yffb0UrUygd0PCoUouMYAjEZoYnTZHFlplDdcVVMMTDEcFFZp-gy0Ii2JM24yg-A__"` のような文字列 を ` src="https://yhc-core-files.core-fw.com/u/3xnu0ulu/bed_sunpo.png"` へ変換する
 *   - 画像URLのクエリパラメータは削除される
 */
const yhcHtmlContentReplaceToPublicDomain = (htmlContent) => {
  // 画像URLの変換
  return htmlContent
    .replace(
      /\ssrc="https:\/\/yhc-core-files\.core-fw\.com\/(.+\.(png|jpg|jpeg|gif|webp|svg|bmp|ico|tiff|tif|eps|psd|ai|indd|pdf|doc|docx|xls|xlsx|ppt|pptx|txt|csv|rtf|html|htm|xml|json|zip|rar|7z|tar|gz|bz2|dmg|exe|msi|apk|ipa|deb|rpm|bin|iso|img|mdf|nrg|toast|vcd|mp3|wav|wma|aac|flac|ogg|ape|alac|aiff|mp4|mkv|avi|mov|wmv|flv|rm|rmvb|mpg|mpeg|vob|asf|ts|m2ts|3gp|3g2|f4v|swf|webm))"/g,
      ' src="https://yhc-core-files-public.core-fw.com/$1"',
    )
    .replace(
      /\ssrc="https:\/\/yhc-core-files\.core-fw\.com\/(.+?)\?[^"]+"/g,
      ' src="https://yhc-core-files-public.core-fw.com/$1"',
    )
}

export default {
  name: 'YhcPublicWebHtmlContentDisplay',
  props: {
    htmlContent: {
      type: String,
      required: true,
    },
  },
  computed: {
    publicHtmlContent(): string {
      return yhcHtmlContentReplaceToPublicDomain(this.htmlContent)
    },
  },
}
</script>
